export default __webpack_public_path__ + "static/media/credit-vertical.d38467f0.png";